export const SpendingCycleIntervals = {
    MONTHLY: 'monthly',
    ANNUALLY: 'annually',
};

export const SpendingCycleIntervalOptions = [
    { value: SpendingCycleIntervals.MONTHLY, label: 'Monthly (Calendar Month)' },
    { value: SpendingCycleIntervals.ANNUALLY, label: 'Annually' },
];
